import api from './api';
export default {
    masterProjects: {
        get: () => api.get('/api/masterprojects')        
    }
}